"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_ENUMS_NL = exports.CATEGORY_TYPES = exports.PRODUCT_CATEGORIES_NL = exports.SOLUTION_PRODUCT_CATEGORIES = exports.SOLUTION_DOMAIN_PRODUCT_CATEGORIES = exports.ProductIDs = exports.getMainProductCategoryFromSolution = exports.MAIN_PRODUCT_CATEGORIES = exports.PRODUCT_CATEGORIES = exports.ProductCategory = void 0;
const glass_1 = require("./glass");
const solution_1 = require("./solution");
const typeHelpers_1 = require("./typeHelpers");
var ProductCategory;
(function (ProductCategory) {
    ProductCategory["Inverter"] = "inverter";
    ProductCategory["PvPanel"] = "pvPanel";
    ProductCategory["Optimizer"] = "optimizer";
    ProductCategory["Other"] = "other";
    /** @deprecated Replaced by individual components of a PV system installation */
    ProductCategory["CompletePvSystem"] = "completePvSystem";
    ProductCategory["InstallationMaterial"] = "installationMaterial";
    ProductCategory["Service"] = "service";
    ProductCategory["RoofInsulationMaterial"] = "roofInsulationMaterial";
    ProductCategory["RoofFinish"] = "roofFinish";
    ProductCategory["Labor"] = "labor";
    ProductCategory["CentralHeatingBoiler"] = "centralHeatingBoiler";
    ProductCategory["Glazing"] = "glazing";
    ProductCategory["WindowFrame"] = "windowFrame";
    ProductCategory["Thermostat"] = "thermostat";
    ProductCategory["Fusebox"] = "fusebox";
    ProductCategory["FloorInsulationMaterial"] = "floorInsulationMaterial";
    ProductCategory["WallInsulationMaterial"] = "wallInsulationMaterial";
    ProductCategory["HeatPump"] = "heatPump";
    ProductCategory["UnderfloorHeating"] = "underfloorHeating";
    ProductCategory["Sedum"] = "sedum";
    ProductCategory["ChargingBox"] = "chargingBox";
    ProductCategory["HomeBattery"] = "homeBattery";
    ProductCategory["MiscellaneousMain"] = "miscellaneousMain";
})(ProductCategory = exports.ProductCategory || (exports.ProductCategory = {}));
exports.PRODUCT_CATEGORIES = (0, typeHelpers_1.enumValues)(ProductCategory);
exports.MAIN_PRODUCT_CATEGORIES = [
    ProductCategory.CompletePvSystem,
    ProductCategory.PvPanel,
    ProductCategory.WallInsulationMaterial,
    ProductCategory.FloorInsulationMaterial,
    ProductCategory.RoofInsulationMaterial,
    ProductCategory.Glazing,
    ProductCategory.CentralHeatingBoiler,
    ProductCategory.HeatPump,
    ProductCategory.UnderfloorHeating,
    ProductCategory.Sedum,
    ProductCategory.ChargingBox,
    ProductCategory.HomeBattery,
    ProductCategory.MiscellaneousMain,
];
function getMainProductCategoryFromSolution(solution) {
    switch (solution) {
        case solution_1.Solution.AtticFloorInsulation:
            return ProductCategory.RoofInsulationMaterial;
        case solution_1.Solution.AirToAirHeatPump:
            return ProductCategory.HeatPump;
        case solution_1.Solution.CentralHeatingBoiler:
            return ProductCategory.CentralHeatingBoiler;
        case solution_1.Solution.CrawlspaceInsulation:
            return ProductCategory.FloorInsulationMaterial;
        case solution_1.Solution.ElectricHeatPump:
            return ProductCategory.HeatPump;
        case solution_1.Solution.FloorInsulation:
            return ProductCategory.FloorInsulationMaterial;
        case solution_1.Solution.HybridHeatPump:
            return ProductCategory.HeatPump;
        case solution_1.Solution.UnderfloorHeating:
            return [ProductCategory.UnderfloorHeating];
        case solution_1.Solution.InnerRoofInsulation:
            return ProductCategory.RoofInsulationMaterial;
        case solution_1.Solution.Miscellaneous:
            return ProductCategory.MiscellaneousMain;
        case solution_1.Solution.PvSystem:
            return [ProductCategory.CompletePvSystem, ProductCategory.PvPanel];
        case solution_1.Solution.WallInsulation:
            return ProductCategory.WallInsulationMaterial;
        case solution_1.Solution.WindowFrames:
            return ProductCategory.Glazing;
        case solution_1.Solution.WindowGlazing:
            return ProductCategory.Glazing;
        case solution_1.Solution.Sedum:
            return [ProductCategory.MiscellaneousMain, ProductCategory.Sedum];
        case solution_1.Solution.ChargingBox:
            return [ProductCategory.MiscellaneousMain, ProductCategory.ChargingBox];
        case solution_1.Solution.HomeBattery:
            return [ProductCategory.MiscellaneousMain, ProductCategory.HomeBattery];
        default:
            throw new Error(`No main category found for solution "${solution}"`);
    }
}
exports.getMainProductCategoryFromSolution = getMainProductCategoryFromSolution;
exports.ProductIDs = {
    extraCostProducts: {
        roofInsulation: {
            flat: '5c619624710b260496aab116',
            slate: '5c619624710b260496aab127',
            nineToTwelveMeters: '5c619624710b260496aab105',
            higherThanTwelveMeters: '5c619624710b260496aab106',
            multipleRoofs: '5c619624710b260496aab119',
        },
        wallInsulation: {
            cherryPicker1: '5ce26284cf4d8e34f2fca509',
        },
        insulationGlazing: {
            replacementThreeToFourMeters: '5c921484710b260496ebc883',
            replacementFourMetersOrMore: '5c921484710b260496ebc884',
            aboveGroundFloorSupplement: '5c921484710b260496ebc889',
        },
    },
    certificateProducts: {
        floorInsulation: { ikob: '5c619624710b260496aab148', insula: '5cc0293d23177f032ebac7ea' },
        roofInsulation: { ikob: '5c7fc99d710b260496d27983', insula: '5cc0296923177f6116bac7ec' },
        wallInsulation: { ikob: '5c619624710b260496aab149', insula: '5cc028d623177f38fdbac7e7' },
    },
};
/**
 * Maps solution domains to all possible product categories its products might have.
 * The solution-specific flag indicates whether or not the products of that category
 * should be resuable between all of the domain's solutions
 */
exports.SOLUTION_DOMAIN_PRODUCT_CATEGORIES = {
    pvSystem: [
        { name: ProductCategory.CompletePvSystem, solutionSpecific: false },
        { name: ProductCategory.PvPanel, solutionSpecific: false },
        { name: ProductCategory.Inverter, solutionSpecific: false },
        { name: ProductCategory.Optimizer, solutionSpecific: false },
        { name: ProductCategory.InstallationMaterial, solutionSpecific: false },
        { name: ProductCategory.Fusebox, solutionSpecific: false },
        { name: ProductCategory.Labor, solutionSpecific: false },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
    wallInsulation: [
        { name: ProductCategory.WallInsulationMaterial, solutionSpecific: true },
        { name: ProductCategory.Labor, solutionSpecific: true },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
    floorInsulation: [
        { name: ProductCategory.FloorInsulationMaterial, solutionSpecific: true },
        { name: ProductCategory.Labor, solutionSpecific: true },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
    roofInsulation: [
        { name: ProductCategory.RoofInsulationMaterial, solutionSpecific: true },
        { name: ProductCategory.RoofFinish, solutionSpecific: true },
        { name: ProductCategory.Labor, solutionSpecific: true },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
    insulationGlazing: [
        { name: ProductCategory.Glazing, solutionSpecific: true },
        { name: ProductCategory.WindowFrame, solutionSpecific: false },
        { name: ProductCategory.Labor, solutionSpecific: true },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
    heating: [
        { name: ProductCategory.CentralHeatingBoiler, solutionSpecific: true },
        { name: ProductCategory.HeatPump, solutionSpecific: true },
        { name: ProductCategory.UnderfloorHeating, solutionSpecific: true },
        { name: ProductCategory.Thermostat, solutionSpecific: false },
        { name: ProductCategory.Labor, solutionSpecific: true },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
    miscellaneous: [
        { name: ProductCategory.Sedum, solutionSpecific: true },
        { name: ProductCategory.ChargingBox, solutionSpecific: true },
        { name: ProductCategory.HomeBattery, solutionSpecific: true },
        { name: ProductCategory.HeatPump, solutionSpecific: true },
        { name: ProductCategory.MiscellaneousMain, solutionSpecific: true },
        { name: ProductCategory.Labor, solutionSpecific: true },
        { name: ProductCategory.Service, solutionSpecific: false },
        { name: ProductCategory.Other, solutionSpecific: false },
    ],
};
const PC = ProductCategory;
/**
 * Mapping solutions to all possible product categories its products might have.
 * Similar to SOLUTION_PRODUCT_CATEGORIES, but exhaustively specified per solution
 */
exports.SOLUTION_PRODUCT_CATEGORIES = {
    /* eslint-disable prettier/prettier */
    pvSystem: [PC.CompletePvSystem, PC.PvPanel, PC.Inverter, PC.Optimizer,
        PC.InstallationMaterial, PC.Fusebox, PC.Labor, PC.Service, PC.Other],
    centralHeatingBoiler: [PC.CentralHeatingBoiler, PC.Thermostat, PC.Labor, PC.Service, PC.Other],
    hybridHeatPump: [PC.HeatPump, PC.Thermostat, PC.Labor, PC.Service, PC.Other],
    electricHeatPump: [PC.HeatPump, PC.Thermostat, PC.Labor, PC.Service, PC.Other],
    airToAirHeatPump: [PC.HeatPump, PC.Thermostat, PC.Labor, PC.Service, PC.Other],
    wallInsulation: [PC.WallInsulationMaterial, PC.Labor, PC.Service, PC.Other],
    floorInsulation: [PC.FloorInsulationMaterial, PC.Labor, PC.Service, PC.Other],
    crawlspaceInsulation: [PC.FloorInsulationMaterial, PC.Labor, PC.Service, PC.Other],
    innerRoofInsulation: [PC.RoofInsulationMaterial, PC.Labor, PC.Service, PC.Other],
    atticFloorInsulation: [PC.RoofInsulationMaterial, PC.Labor, PC.Service, PC.Other],
    windowGlazing: [PC.Glazing, PC.WindowFrame, PC.Labor, PC.Service, PC.Other],
    windowFrames: [PC.WindowFrame, PC.Labor, PC.Service, PC.Other],
    underfloorHeating: [PC.UnderfloorHeating, PC.Labor, PC.Service, PC.Other],
    homeBattery: [PC.HomeBattery, PC.Labor, PC.Service, PC.Other],
    sedum: [PC.Sedum, PC.Other],
    chargingBox: [PC.ChargingBox, PC.Other],
    miscellaneous: [PC.MiscellaneousMain],
    /* eslint-enable prettier/prettier */
};
exports.PRODUCT_CATEGORIES_NL = {
    completePvSystem: 'PV-systeem',
    pvPanel: 'Paneel',
    inverter: 'Omvormer',
    optimizer: 'Optimizer',
    installationMaterial: 'Installatiemateriaal',
    wallInsulationMaterial: 'Isolatiemateriaal',
    floorInsulationMaterial: 'Isolatiemateriaal',
    roofInsulationMaterial: 'Isolatiemateriaal',
    roofFinish: 'Afwerking',
    centralHeatingBoiler: 'CV-ketel',
    heatPump: 'Warmtepomp',
    underfloorHeating: 'Vloerverwarming',
    thermostat: 'Thermostaat',
    fusebox: 'Groepenkast',
    glazing: 'Glas',
    windowFrame: 'Kozijn',
    labor: 'Arbeid',
    miscellaneousMain: 'Diversen',
    service: 'Meerkosten',
    other: 'Maatwerk',
    sedum: 'Sedum',
    chargingBox: 'Laadpaal',
    homeBattery: 'Thuisbatterij',
};
/**
 * Maps the product categories specified above to the names of the corresponding GraphQL types.
 * Note: Some have slight name changes, e.g. wallInsulationMaterial -> WallCavityInsulation
 */
exports.CATEGORY_TYPES = {
    completePvSystem: 'CompletePvSystem',
    pvPanel: 'PvPanel',
    inverter: 'Inverter',
    thermostat: 'Thermostat',
    fusebox: 'Fusebox',
    centralHeatingBoiler: 'Boiler',
    optimizer: 'Optimizer',
    installationMaterial: 'InstallationMaterial',
    wallInsulationMaterial: 'WallCavityInsulation',
    floorInsulationMaterial: 'FloorInsulation',
    roofInsulationMaterial: 'RoofInsulation',
    roofFinish: 'RoofFinish',
    glazing: 'Glazing',
    windowFrame: 'WindowFrame',
    heatPump: 'HeatPump',
    underfloorHeating: 'UnderfloorHeating',
    labor: 'Labor',
    miscellaneousMain: 'MiscellaneousMain',
    service: 'Service',
    other: 'Other',
    sedum: 'Sedum',
    chargingBox: 'ChargingBox',
    homeBattery: 'HomeBattery',
};
/**
 * Maps product field values to their Dutch equivalents, e.g. material types
 * TODO: needs type definitions
 */
exports.PRODUCT_ENUMS_NL = {
    ...exports.PRODUCT_CATEGORIES_NL,
    // PriceUnit
    unit: 'stuk',
    m: 'm',
    m2: 'm²',
    m3: 'm³',
    hour: 'uur',
    // PanelType
    glassFoil: 'Glas-folie',
    glassGlass: 'Glas-glas',
    integrated: 'Geïntegreerd',
    roofTile: 'Dakpan',
    tier: 'Klasse',
    // CellType
    poly: 'Polykristallijn',
    mono: 'Monokristallijn',
    standard: 'Standaard',
    perc: 'Perc',
    nType: 'N-Type',
    hjt: 'HJT',
    // Color
    fullBlack: 'Fullblack',
    black: 'Zwart',
    silver: 'Zilver',
    blue: 'Blauw',
    white: 'Wit',
    green: 'Groen',
    red: 'Rood',
    gray: 'Grijs',
    brown: 'Bruin',
    darkBlue: 'Donkerblauw',
    // GlassType
    ...glass_1.GLASS_TYPE_NL,
    // CommunicationProtocol
    openTherm: 'OpenTherm®',
    aanUit: 'Aan/Uit',
    // HeatPumpType
    groundWaterWater: 'Grondwater/water',
    brineWater: 'Brine/water',
    airWater: 'Lucht/water',
    airAir: 'Lucht/lucht',
    hybrid: 'Hybride',
    // Monitoring
    none: 'Geen',
    wired: 'Bedraad',
    wireless: 'Draadloos',
    both: 'Beiden',
    // ConnectionType
    serial: 'Serieel',
    individual: 'Individueel',
    // Placement (roof)
    interior: 'Interieur',
    exterior: 'Exterieur',
    // WallInsulationMaterial
    foam: 'Na-isolatie schuim',
    pearls: 'Parels',
    glassWool: 'Glaswol',
    // FloorInsulationMaterial
    pur: 'PUR',
    ecofoam: 'Milieuvriendelijk schuim',
    insulationFoil: 'Isolatiefolie',
    thermalInsulationPads: 'Thermoskussens',
    // Stookinstellingen
    alternating: 'Hybrid/All-electric',
    allElectric: 'All-electric',
    combined: 'Hybrid',
    // SplitUnit
    split: 'Split',
    monoblock: 'Monoblock',
    // MainsConnection
    singlePhase: '230V/1',
    threePhase: '400V/3',
    // ConnectionLoad (Aansluitwaarde)
    onePhase25Ampere: '1x25A',
    onePhase35Ampere: '1x35A',
    onePhase40Ampere: '1x40A',
    threePhase25Ampere: '3x25A',
    // Refrigerant
    R32: 'R32',
    R410: 'R410',
    R290: 'R290',
    // Vapor permeability
    open: 'Damp-open',
    semiOpen: 'Semi damp-open',
    closed: 'Damp-dicht',
};
